import { createFileRoute } from '@tanstack/react-router';
import { RequireService } from '@/components/shared/require-service';
import { CategoriesPage } from '@/features/categories/categories-page';

export const Route = createFileRoute('/_app/settings/categories')({
  component: () => (
    <RequireService service="CATEGORY_LIST">
      <CategoriesPage />
    </RequireService>
  ),
});
